import ownerRezLogo from './images/ownerRezLogo.png';
import touchStayLogo from './images/touchStayLogo.png';
import stayFiLogo from './images/stayFiLogo.png';
import hospitableLogo from './images/hospitableLogo.svg';
import airbnbLogo from './images/airbnbLogo.png';
import guestyLogo from './images/guestyLogo.svg';
import guestyLiteDarkLogo from './images/GuestyLiteDarkLogo.png';
import lodgifyLogo from './images/lodgifyLogo.png';
import hostawayLogo from './images/HostawayLogo.png';
import turnoLogo from './images/turnoLogo.svg';
import hostfullyLogo from './images/hostfullyLogo.svg';
import hosttoolsLogo from './images/hosttoolsLogo.svg';
import hostbuddyLogo from './images/hostbuddyLogo.png';
import havenLogo from './images/havenLogo.png';
import {
  hostawayStepByStepInstructions,
  lodgifyStepByStepInstructions,
  ownerrezStepByStepInstructions,
  guestyLiteStepByStepInstructions,
  hostfullyStepByStepInstructions,
  guestyStepByStepInstructions,
  hospitableStepByStepInstructions,
} from './StepByStepSection/index.js';
import React from 'react';
import { INTEGRATION_INSTRUCTIONS } from '../../api/partners';

import {
  hospitableConnectApi,
  ownerRezApi,
  hospitableApi,
  turnoApi,
  hostfullyApi,
} from 'api/partners';

import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';
import { IntegrationType } from 'api/types/partners';
import { IS_STAGING } from 'consts';

export const partnersData = {
  ownerrez: {
    name: IntegrationType.OWNERREZ,
    title: 'Get Started',
    copy: 'Learn how to import your OwnerRez properties with this video.',
    videos: [
      {
        id: '91GHpPJoE24',
        title: 'How it Works',
        start: 85,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue to connect your OwnerRez account.',
      '2) Choose which properties you’d like to create stores for, or create one store from your listings and later duplicate it to your liking.',
      '3) Add or edit products - don’t forget to update your descriptions!',
      '4) One finished, add your store link in your OwnerRez automated messages with custom code {PXHOSTCO}. We recommend sharing your store link at booking, a week before check-in, and at check-in.',
      <>
        <div>
          5) We recommend sharing your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          OwnerRez booking times, show you a visual reminder, and add notes in your booking notes
          field <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If your stores were created before this date, these early check-in and late check-out
            tiles will not sync with the OwnerRez calendar because older tile versions don’t include
            the required time fields. To fix this: replace your old tiles with the updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.OWNERREZ),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click continue to connect your OwnerRez account.  Once you log in, click the button to authorize the Host Co:',
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step1} />{' '}
      </>,
      '2) Choose which properties you’d like to create stores for, or link your existing stores to existing Host Co stores, or create one store from your listings and later duplicate it to your liking.',
      '3) Add or edit products - don’t forget to update your descriptions!',
      '4) Once finished, add your store links in your OwnerRez automated messages with custom field {PXHOSTCO}. We recommend sharing your store link at booking, a week before check-in, and at check-in. For message examples, click “Share”  on any Host Co store.',
      'Note: The integration will automatically add the matching store link to the correct property.  To check that your custom field is attached to the correct store, go to OwnerRez “settings”, and under “Workflow & Devices” look for “Custom Field Definitions”. Click this and select “PXHOSTCO”.  This will show each link that’s connected to each property. You can cross-reference the Host Co store link under the “Share Store” button in each store.',
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step2} />{' '}
        <img src={ownerrezStepByStepInstructions.ownerrez_step3} />{' '}
      </>,
      '5) Make sure you are talking about your Host Co offers in your messages. To add a custom message in Owner Rez, click on “Settings” and then under “Messages,” look for  “Templates” to create a custom message where you’ll use {PXHOSTCO}.  You will also need to set up “Triggers,” which can be found next to the templates, to schedule when they go out.',
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step4} />{' '}
        <img src={ownerrezStepByStepInstructions.ownerrez_step5} />{' '}
      </>,
      'To preview template messages with your Host Co link, navigate to Settings > Templates and select the template type you want to preview (Email, Channel, or SMS). After saving your template, click the Preview button at the top of the screen.',
      'For Channel Templates specifically, you can preview how your message will appear to guests and also select different properties and bookings from dropdown lists to see how the template renders with different guest information. Click Close to exit the preview.',
      <div key="ownerrez-step5">
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '15px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          OwnerRez booking times, show a visual reminder, and add notes in your booking notes field
          unless your Host Co stores were created before May 14, 2025.
        </p>
        <p>
          If your stores were created before this date, these early check-in and late check-out
          tiles will not sync with the OwnerRez calendar because older tile versions don’t include
          the required time fields. To fix this, replace your old tiles with the updated versions.
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
      </div>,
      <>
        <img src={ownerrezStepByStepInstructions.ownerrez_step6} />{' '}
        <img src={ownerrezStepByStepInstructions.ownerrez_step7} />{' '}
      </>,
      <div key="ownerrez-step6">
        <b>Note: Only one Host Co account can be linked to one OwnerRez account.</b>
        <p style={{ marginTop: '15px' }}>
          To disconnect your OwnerRez and Host Co account, re-initiate the integration and use your
          new login for either OwnerRez or The Host Co. This will update the connection to your new
          account and remove the connection from your original account. For additional help, contact
          support@thehost.co
        </p>
      </div>,
    ],
    onContinue: () => ownerRezApi.authenticate(),
  },
  hospitableconnect: {
    name: IntegrationType.HOSPITABLE_CONNECT,
    title: 'Get Started',
    copy: 'Learn how to import your Airbnb listings with this video.',
    heading: 'Quick-Start Instructions',
    videos: [
      {
        id: 's3nJDVreGPY',
        title: 'How it Works',
      },
    ],
    quick_start_instructions: [
      '1) Click continue below to connect your Airbnb account to The Host Co. using Hospitable Connect.',
      '2) Choose which properties you want to create stores for.',
      '3) Add products to your new stores and start making money!',
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSPITABLE_CONNECT),
    ],
    onContinue: () => hospitableConnectApi.authenticate(),
  },
  hospitable: {
    name: IntegrationType.HOSPITABLE,
    title: 'Get Started',
    copy: 'Learn how to connect to your Hospitable account with this video.',
    videos: [
      {
        id: 'pAdyEKL_lR8',
        title: 'How it Works',
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Hospitable account to The Host Co.',
      '2) Choose which properties you want to create stores for.',
      '3) Add products to your new stores and start making money!',
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSPITABLE),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click the continue button in Host Co to connect your Hospitable account.',
      '2) A screen will pop up asking you to authorize the Host Co.',
      <img key="hospitable-step1" src={hospitableStepByStepInstructions.hospitable_step1} />,
      '3) You will be taken back to the Host Co and asked to link properties to existing stores or to create new stores.',
      <img key="hospitable-step2" src={hospitableStepByStepInstructions.hospitable_step2} />,
      '4) Choose which stores you’d like to create stores for or connect to existing listings in your Host Co account.',
      '5) Update your upsells in each store with accurate prices and availability.',
      '6) Share your Host Co links in your outgoing Hospitable Messaging using the short code %upsell%. When you link your properties, Hospitable will autopopulate your %upsell% with your Host Co Store link. To check (or change the link), in Hospitable go to Properties - Details - Arrival and scroll to bottom of the screen.',
      <img key="hospitable-step3" src={hospitableStepByStepInstructions.hospitable_step3} />,
      <div key="hospitable-step7">
        <b>7) Sharing Message Templates</b>
        <p style={{ marginTop: '15px' }}>
          To see templates of what other hosts are sending, click “Share Store” on any Host Co
          store. We recommend sharing your Host Co store links at these key moments:
        </p>
        <ul style={{ marginLeft: '30px' }}>
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in instructions</li>
        </ul>
      </div>,
      <div key="hospitable-check-in-note">
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '15px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          Hospitable booking times, and add notes to your booking notes field, unless your Host Co
          stores were created before May 14, 2025.
        </p>
        <p>
          If your stores were created before this date, these tiles will not sync with the
          Hospitable calendar because older versions don’t include the required time fields. To fix
          this, replace your existing tiles with the updated versions.
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
      </div>,
    ],
    onContinue: () => hospitableApi.authenticate(),
  },
  guesty: {
    name: IntegrationType.GUESTY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Guesty account with this video.',
    videos: [
      {
        id: 'Aqkjvi-VmTM',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Guesty account.',
      '2) You’ll be asked for a Guesty integration token. If you don’t have a token we’ll show you where to generate one.',
      '3) Paste your integration token into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Each store link is pre-populated in Guesty and can be added to your outgoing messages by hitting "+Add variable" and selecting "HostCo".',
      <>
        <div>
          6) Share your Host Co store links in your outgoing Guesty messages. We recommend sharing
          your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Guesty
          booking times, show you a visual reminder, and add notes in your booking notes field,{' '}
          <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If your stores were created before this date, these early check-in and late check-out
            tiles will not sync with the Guesty calendar because older tile versions don’t include
            the required time fields. To fix this: replace your old tiles with the updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.GUESTY),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click “Continue” below to connect your Guesty account.',
      '2) You’ll be asked for a Guesty integration token. If you don’t have a token we’ll show you where to generate one.',
      <div key="guesty-token-steps">
        <img src={guestyStepByStepInstructions.guesty_step1} />
        <img src={guestyStepByStepInstructions.guesty_step2} />
        <img src={guestyStepByStepInstructions.guesty_step3} />
        <img src={guestyStepByStepInstructions.guesty_step4} />

        <div>
          <br />
          3) Paste your integration token into the provided form (required only once).
          <br />
          4) Choose which properties you’d like to create stores for and modify stores to your
          liking.
        </div>

        <img src={guestyStepByStepInstructions.guesty_step5} />

        <div>
          <br />
          5) Each store link is pre-populated in Guesty and can be added to your outgoing messages
          <p>
            by hitting &quot;message automation&quot;, &quot;+Add variable&quot; and selecting
            &quot;HostCo&quot;.
          </p>
        </div>

        <img src={guestyStepByStepInstructions.guesty_step6} />
      </div>,
      <div key="guesty-message-automation">
        <div>
          Click &quot;add message automation&quot; or click the three dots on an existing message
          and choose &quot;edit&quot;.
        </div>

        <img src={guestyStepByStepInstructions.guesty_step7} />
        <div>
          <br />
          Then click &quot;Add variable&quot;
        </div>

        <img src={guestyStepByStepInstructions.guesty_step8} />

        <div>
          <br />
          Under custom variables, choose &quot;HostCo&quot;
        </div>

        <img src={guestyStepByStepInstructions.guesty_step9} />
      </div>,

      <div key="guesty-share-note">
        6) Share your Host Co store links in your outgoing Guesty messages. We recommend sharing
        your store link:
        <ul className="Step_SubList">
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in notes</li>
          <li>For message examples, click “Share“ on any Host Co store.</li>
        </ul>
        <p>
          <b>Note on Early Check-In & Late Check-Out</b>
        </p>
        <p>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Guesty
          booking times, show you a visual reminder, and add notes in your booking notes field,
          unless your Host Co stores were created before May 14, 2025.
        </p>
        <p>
          If your stores were created before this date, these early check-in and late check-out
          tiles will not sync with the Guesty calendar because older tile versions don’t include the
          required time fields. To fix this: replace your old tiles with the updated versions.
          <a
            href="https://www.youtube.com/watch?v=vMtt_rK4Sgg"
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
        <p>Note: Only one Host Co account can be linked to one Guesty account.</p>
        <p>
          To disconnect your Guesty and Host Co account, re-initiate the integration and use your
          login for either Guesty or The Host Co. This will update the connection to your new
          account and remove the connection from your original account. For additional help, contact
          support@thehost.co
        </p>
        <br />
        <p>
          <b>Notes automatically get added to your Guesty Calendar</b>
        </p>
        <p>
          When a purchase is made in the Host Co with a date attached to it, those purchases will
          automatically show up on your Guesty calendar (as long as the store is linked to a
          specific property). To ensure there’s a date attached, choose a product in the Host Co
          that you want to show up on your calendar and select either “No, I need notice ahead of
          time” or “Yes, it is available immediately but ask guest for date of use”.
        </p>
      </div>,

      <img key="guesty-step10" src={guestyStepByStepInstructions.guesty_step10} />,

      <div key="guesty-calendar-note">
        When a guest checks out, they’ll be asked to enter the date of use. That date will throw a
        note onto your calendar in Guesty. It won’t be visible there’s a note unless you click on
        the reservation itself in Guesty.
      </div>,

      <img key="guesty-step11" src={guestyStepByStepInstructions.guesty_step11} />,

      <div key="guesty-ending">
        Now, it’s never been easier to track your Host Co sales across platforms!
      </div>,
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.GUESTY.toLowerCase() },
      }),
  },
  guesty_lite: {
    name: IntegrationType.GUESTY_LITE,
    title: 'Get Started',
    copy: 'Learn how to connect to your Guesty Lite account with this video.',
    videos: [
      {
        id: 'Aqkjvi-VmTM',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Guesty Lite account.',
      '2) You’ll be asked for a Guesty Lite integration token. If you don’t have a token we’ll show you where to generate one.',
      '3) Paste your integration token into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Copy your store links in the Host Co and paste them in your outgoing Guesty Lite automated messages.',
      INTEGRATION_INSTRUCTIONS(IntegrationType.GUESTY_LITE),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click "Continue" below to connect your Guesty Lite account.',
      '2) You’ll be asked for a Guesty integration token. If you don’t have a token we’ll show you where to generate one.',
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step1} />
      </>,
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step2} />
      </>,
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step3} />
      </>,
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step4} />
      </>,
      '3) Paste your integration token into the provided form (required only once).',

      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step5} />
      </>,
      '5) Each store link is pre-populated in Guesty Lite and can be added to your outgoing messages by hitting "message automation”, “+Add variable" and selecting "HostCo".',
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step6} />
      </>,
      'Click “add message automation” or click the three dots on an existing message and choose “edit”.',
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step7} />
      </>,
      'Then click “Add variable”',
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step8} />
      </>,
      'Under custom variables, choose “HostCo”',
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step9} />
      </>,
      <div key="guesty-lite-share-note">
        6) Share your Host Co store links in your outgoing Guesty Lite messages. We recommend
        sharing your store link:
        <ul className="Step_SubList">
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in notes</li>
          <li>For message examples, click “Share“ on any Host Co store.</li>
        </ul>
        <p>
          <b>Note on Early Check-In & Late Check-Out</b>
        </p>
        <p>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Guesty
          Lite booking times, show you a visual reminder, and add notes in your booking notes field,
          unless your Host Co stores were created before May 14, 2025.
        </p>
        <p>
          If your stores were created before this date, these early check-in and late check-out
          tiles will not sync with the Guesty Lite calendar because older tile versions don’t
          include the required time fields. To fix this: replace your old tiles with the updated
          versions.
          <a
            href="https://www.youtube.com/watch?v=vMtt_rK4Sgg"
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
        <p>Note: Only one Host Co account can be linked to one Guesty Lite account.</p>
        <p>
          To disconnect your Guesty Lite and Host Co account, re-initiate the integration and use
          your login for either Guesty Lite or The Host Co. This will update the connection to your
          new account and remove the connection from your original account. For additional help,
          contact support@thehost.co
        </p>
        <br />
        <p>
          <b>Notes automatically get added to your Guesty Lite Calendar</b>
        </p>
        <p>
          When a purchase is made in the Host Co with a date attached to it, those purchases will
          automatically show up on your Guesty Lite calendar (as long as the store is linked to a
          specific property). To ensure there’s a date attached, choose a product in the Host Co
          that you want to show up on your calendar and select either “No, I need notice ahead of
          time” or “Yes, it is available immediately but ask guest for date of use”.
        </p>
      </div>,
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step10} />
      </>,
      <p key="guesty-track-sales-note">
        When a guest checks out, they&apos;ll be asked to enter the date of use. That date will
        throw a note onto your calendar in Guesty Lite. It won&apos;t be visible there unless you
        click on the reservation itself in Guesty Lite.
      </p>,
      <>
        <img src={guestyLiteStepByStepInstructions.guesty_lite_step11} />
      </>,
      <p key="hostfully-track-sales-ending">
        Now, it&apos;s never been easier to track your Host Co sales across platforms!
      </p>,
    ],

    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.GUESTY_LITE.replace(' ', '_').toLowerCase() },
      }),
  },
  hostaway: {
    name: IntegrationType.HOSTAWAY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Hostaway account with this video.',
    videos: [
      {
        id: '2Y5KOcYP5Us',
        title: 'How it Works',
        start: 85,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Hostaway account.',
      '2) You’ll be asked for a Hostaway client ID and API key. We’ll show you where to get credentials if you don’t have them.',
      '3) Paste your credentials into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Add your store links in your outgoing Hostaway messages by hitting "+Add Variable" and selecting "listing_hostco".',
      <>
        <div>
          6) We recommend sharing your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          Hostaway booking times, show you a visual reminder, and add notes in your booking notes
          field, <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If your stores were created before this date, these early check-in and late check-out
            tiles will not sync with the Hostaway calendar because older tile versions don’t include
            the required time fields. To fix this: replace your old tiles with the updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSTAWAY),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click the continue button in Host Co to connect your Hostaway account.',
      '2) You’ll be asked for a Hostaway client ID and API key. Click the blue link on the Host Co pop-up, and we’ll send you to Hostaway to get your credentials. If you need to log into Hostaway first, after login, revisit the blue link in our Host Co API key pop-up to reach the correct window in Hostaway.',
      '3) Click “create” on the Hostaway Public API Screen. You can name the integration whatever you like (we recommend using Host Co so you find it easily in the future).',
      <>
        <img src={hostawayStepByStepInstructions.step1} />{' '}
      </>,
      '4) Scroll down the “partner” list looking for The Host Co. It’s about ⅔ the way down. This will generate the API key. Copy this, return to the Host Co, and paste this API key into the pop-up on the Host Co integration screen. If the API pop-up screen has closed, hit “continue” on the Host Co + Hostaway integration page to make the API screen pop up again.',
      <>
        <img src={hostawayStepByStepInstructions.step2} />{' '}
        <img src={hostawayStepByStepInstructions.step3} />{' '}
      </>,
      '5) Paste your credentials into the provided form (required only once).',
      '6) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '7) Add your store links in your outgoing Hostaway messages by hitting "{ }" inside your messaging templates and selecting "listing_hostco".',
      <>
        <img src={hostawayStepByStepInstructions.step4} />
        <img src={hostawayStepByStepInstructions.step5} />
        <img src={hostawayStepByStepInstructions.step6} />
      </>,
      'To cross-reference that the link is correct, go to each property and click on custom fields - you’ll find the link there after the integration.',
      <>
        <img src={hostawayStepByStepInstructions.step7} />{' '}
      </>,
      'It can also be found under “additional info” on the listing page.',
      '8) To see templates of what other hosts say in their messages, hit “share store” on any Host CO store. We recommend sharing your Host Co store links during these times:',
      <div key="hostaway-recommendations">
        <ul className="Step_SubList" key="hostaway-recommendations-list">
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in notes</li>
        </ul>
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '25px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your
          Hostaway booking times, show you a visual reminder (sticky note), and add notes in your
          booking notes field, unless your Host Co stores were created before May 14, 2025. If your
          stores were created before this date, these early check-in and late check-out tiles will
          not sync with the Hostaway calendar because older tile versions don’t include the required
          time fields. To fix this, replace your old tiles with the updated versions.{' '}
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
      </div>,
      <>
        <img src={hostawayStepByStepInstructions.step8} />
        <img src={hostawayStepByStepInstructions.step9} />
        <img src={hostawayStepByStepInstructions.step10} />
      </>,
      <div key="hostaway-steps">
        <b>Note on Multiple Accounts</b>
        <p style={{ marginTop: '15px' }}>
          Only one Host Co account can be linked to a single Lodgify account.
        </p>
        <p>
          {' '}
          To disconnect your Hostaway and Host Co account, re-initiate the integration and use your
          new login for either Hostaway or The Host Co. This will update the connection to your new
          account and remove the connection from your original account.
        </p>
        <p>For additional help, contact support@thehost.co</p>
      </div>,
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.HOSTAWAY.toLowerCase() },
      }),
  },
  lodgify: {
    name: IntegrationType.LODGIFY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Lodgify account with this video.',
    videos: [
      {
        id: '1-DZDNPK1P4',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click continue below to connect your Lodgify account.',
      '2) You’ll be asked for a Lodgify API key. We’ll show you where to get credentials if you don’t have them.',
      '3) Paste your API key into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Share your Host Co store links in your outgoing Lodgify messages.',
      <>
        <div>
          6) We recommend sharing your store link:
          <ul style={{ marginLeft: '30px' }}>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message examples, click Share on any Host Co store.</li>
          </ul>
        </div>
      </>,
      <>
        <div>
          <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
            Note on Early Check-In & Late Check-Out{' '}
          </p>{' '}
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Lodgify
          booking times, show you a visual reminder, and add notes in your booking notes field,{' '}
          <b>unless your Host Co stores were created before May 14, 2025.</b>
          <p style={{ marginTop: '15px' }}>
            If yourIf your stores were created before this date, these early check-in and late
            check-out tiles will not sync with the Lodgify calendar because older tile versions
            don’t include the required time fields. To fix this: replace your old tiles with the
            updated versions.
            <a
              href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Click here to learn more.
            </a>
          </p>
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.LODGIFY),
    ],
    bottom_heading: 'Step-by-Step Instructions',
    step_by_step_instructions: [
      '1) Click continue below to connect your Lodgify account.',
      '2) You’ll be asked for a Lodgify API key. Click the blue hyperlink to go to the Hostway page inside your Lodgify account.',
      '3) On the Lodgify page for The Host Co, scroll down to “copy your Lodgify API key and paste it into the partners section on the Host Co”. Click on the code in the box to automatically copy the code (if you hover over the box that says “copy API code,” it will reveal the code.',
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step1} />{' '}
        <img src={lodgifyStepByStepInstructions.lodgify_step2} />{' '}
      </>,
      '4) Go back to the Host Co Partners Page and click on Lodgify and then “continue” unless the API key box is still up on your screen. Paste your API key into the provided form (required only once)',
      '5)  Choose which stores you’d like to create stores for or connect to existing listings in your Host Co account.',
      <div key="lodgify-step5">
        <ul className="Step_SubList" key="lodgify-recommendations-list">
          <li>Update your upsells in each store with accurate prices and availability.</li>
          <li>Share your Host Co links in your outgoing Lodgify Messaging</li>
        </ul>
      </div>,
      '6) Sharing Message Templates',
      'To see templates of what other hosts are sending, click “Share Store” on any Host Co store. We recommend sharing your Host Co store links at these key moments:',
      <div key="lodgify-step6">
        <ul className="Step_SubList" key="lodgify-recommendations-list">
          <li>In your “Thanks for booking” message</li>
          <li>One week before check-in</li>
          <li>In your check-in instructions</li>
        </ul>
      </div>,
      <div key="lodgify-step7">
        <b>Note on Early Check-In & Late Check-Out</b>
        <p style={{ marginTop: '15px' }}>
          The Host Co Early Check-In and Late Check-Out tiles will automatically update your Lodgify
          booking times, and add notes to your booking notes field—unless your Host Co stores were
          created before May 14, 2025. If your stores were created before this date, these tiles
          will not sync with the Lodgify calendar because older versions don’t include the required
          time fields. To fix this, replace your existing tiles with the updated versions.{' '}
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sgg`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
        </p>
      </div>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step3} />{' '}
        <img src={lodgifyStepByStepInstructions.lodgify_step4} />{' '}
        <img src={lodgifyStepByStepInstructions.lodgify_step5} />{' '}
      </>,
      <div key="lodgify-step8">
        <p>
          <b>
            Adding Host Co links to show up in{' '}
            <a
              href={`http://Booking.com`}
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: '5px' }}
            >
              Booking.com
            </a>{' '}
            and VRBO
          </b>
        </p>
        <p>
          {' '}
          Your Host Co links will not show in{' '}
          <a
            href={`http://Booking.com`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Booking
          </a>{' '}
          or VRBO unless the following steps are taken.
        </p>
        <ol type="1" className="Step_SubList" key="lodgify-recommendations-list">
          <li>
            Under Rentals on the left-hand side, pick a specific property you want to add your link
            to the Host Co.
          </li>
        </ol>
      </div>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step6} />{' '}
      </>,
      <p key="lodgify9">
        To start, go under “Rentals” on the lefthand side of the screen. Pick which property you
        want to add this to and then click on “messaging placeholders”. You can use any messaging
        placeholder you want, but we recommend {'{{ LocalGuide }}'}. If you already have a local
        guide in here, you can use ANY unused messaging placeholder OR consider adding your actual
        guide into your Host Co store. - hyperlink to below images.
      </p>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step7} />{' '}
        <img src={lodgifyStepByStepInstructions.lodgify_step8} />{' '}
        <img src={lodgifyStepByStepInstructions.lodgify_step9} />{' '}
      </>,
      <p key="lodgify10">
        Otherwise, scroll down to {'{{LocalGuide}}'} and click the {'<>'} HTML buttons.
      </p>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step10} />{' '}
      </>,
      <p key="lodgify11">
        Then click the share store button on Host Co in your store and copy the link here in the{' '}
        {'{{ LocalGuide }}'} section of your Lodgify Messaging Placeholders.
      </p>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step11} />{' '}
      </>,
      <p key="lodgify12">
        On the lefthand side of the screen in Lodgify, click on settings and then custom
        notifications to get into your automatic messages.
      </p>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step12} />{' '}
      </>,
      <p key="lodgify13">
        Either create a new notification or edit an existing notification and then when you want to
        add your link, click on messaging placeholder and select {'{{ LocalGuide }}'} or whichever
        messaging placeholder box you’re using for that property to insert the link.
      </p>,
      <>
        <img src={lodgifyStepByStepInstructions.lodgify_step13} />{' '}
      </>,
      <p key="lodgify14">
        In order to properly preview this link, you will need to create a reservation and send the
        message to yourself to see how the link will actually look to your guests. You’re all set!
      </p>,
      <div key="lodgify-step15">
        <b>Note on Multiple Accounts</b>
        <p style={{ marginTop: '15px' }}>
          Only one Host Co account can be linked to a single Lodgify account.
        </p>
        <p>
          {' '}
          To disconnect your Lodgify and Host Co account, re-initiate the integration and log in
          with your new Lodgify or Host Co credentials. This will update the connection and remove
          access from the previous account.
        </p>
        <p>For additional help, contact support@thehost.co</p>
      </div>,
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.LODGIFY.toLowerCase() },
      }),
  },
  turno: {
    name: IntegrationType.TURNO,
    title: 'Get Started',
    copy: 'Learn how to import your Turno properties with this video.',
    videos: [
      {
        id: '2Jl6ErmIgXI',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click Connect and your Turno properties will start importing to The Host Co.',
      '2) On the next screen, choose whether to create new stores or link existing Host Co stores to the right Turno properties.',
      '3) Your new stores will auto-fill with optional alterations (like early check-in/late check-out) and popular local services.',
      '4) Once a guest books an early check-in or late check-out and it’s approved, your Turno calendar updates automatically — no manual edits needed.',
      '* For existing Host Co users: you can link your imported Turno properties with existing stores on the next page.',
      INTEGRATION_INSTRUCTIONS(IntegrationType.TURNO),
    ],
    onContinue: () => turnoApi.authenticate(),
  },
  hostfully: {
    name: IntegrationType.HOSTFULLY,
    title: 'Get Started',
    copy: 'Learn how to import your Hostfully properties with this video.',
    videos: [
      {
        id: 'Rq_sYjCiIr0',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Quick-Start Instructions',
    quick_start_instructions: [
      '1) Click “continue” below to initiate the integration. On the following page, click “allow” to connect The Host Co to Hostfully.',
      <>
        <div>
          2) Once the integration has been allowed, click on the
          <a
            href={
              IS_STAGING
                ? 'https://sandbox.hostfully.com/app/#/integrations/details/thehostco'
                : 'https://platform.hostfully.com/app/#/integrations/details/thehostco'
            }
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px', marginRight: '5px' }}
          >
            Host Co Integration Page
          </a>
          (make sure you are logged in).
        </div>
      </>,
      '3) Toggle on each property you want to connect to The Host Co.',
      '4) Return to The Host Co and navigate back to Partners → Hostfully  →  Start now (this will bring you back to this instruction page with the video). Click “continue” to import your Hostfully properties into The Host Co.',
      '5) Choose whether to create new stores, link existing Host Co stores to Hostfully properties, or skip any properties you don’t want to connect. You can always come back and add more stores later.',
      'Recommended: The Host Co early check-in and late check-out tile will automatically modify your Hostfully calendar times, but if you’d like to create a visual blue dot to indicate early check-ins and late check-outs on your Hostfully calendar:',
      'I) Under Agency Settings, create a Service provider named The Host Co.',
      'II) Add two Services: early check-in and late check-out. Note: The service provider name (The Host Co) and service names must be spelled correctly to trigger the blue dots.',
      <>
        <div>
          If your Host Co stores were created before May 14, 2025: your Early Check-In and Late
          Check-Out tiles will not sync with Hostfully’s calendar, as these older tiles do not
          include the new required time fields. To fix this, you’ll need to replace your old tiles
          with the updated versions.
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sggtform.hostfully.com/app/#/integrations`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more.
          </a>
          .
        </div>
      </>,
      INTEGRATION_INSTRUCTIONS(IntegrationType.HOSTFULLY),
    ],
    bottom_heading: 'Step-by-Step Instructions',

    step_by_step_instructions: [
      '1) Log in to your Host Co account.',

      <div key="hostfully-partner">
        2) Go to <b>Partners → Hostfully.</b>
      </div>,

      <img key="hostfully-step1" src={hostfullyStepByStepInstructions.hostfully_step1} />,

      '3) Click Continue to start the integration.',

      <div key="hostfully-authorization">
        <div>
          4) On the authorization screen, click <b>Allow</b> to connect The Host Co to Hostfully.{' '}
          <b>Make sure you are logged into your Hostfully account for this step.</b>
        </div>
        <img src={hostfullyStepByStepInstructions.hostfully_step2} />
      </div>,

      <div key="hostfully-step2">
        <b>Step 2 — Open the Hostfully Integrations Page</b>
        <p style={{ marginTop: '15px' }}>
          After authorization, click the <b>Hostfully Integrations Page</b> link provided in The
          Host Co (ensure you&apos;re logged into Hostfully). If the message disappears before you
          had a chance to click it, just hit refresh on your browser.
        </p>
      </div>,

      <img key="hostfully-step3-img" src={hostfullyStepByStepInstructions.hostfully_step3} />,

      <div key="hostfully-step3">
        <b>Step 3 — Enable properties inside Hostfully</b>
        <p style={{ marginTop: '15px' }}>On the Hostfully integrations page:</p>
        <ol style={{ marginLeft: '25px' }}>
          <li>
            Toggle the integration <b>ON</b>.
          </li>
        </ol>
      </div>,

      <img key="hostfully-step4-img" src={hostfullyStepByStepInstructions.hostfully_step4} />,

      <p key="hostfully-required-note">
        This step is required before Host Co can retrieve your listings.
      </p>,

      <div key="hostfully-step4">
        <b>Step 4 — Return to The Host Co and import your listings</b>
        <p style={{ marginTop: '15px' }}>Go back to The Host Co and navigate to:</p>
        <p>
          <b>Partners → Hostfully → Start Now</b>
        </p>
        <img src={hostfullyStepByStepInstructions.hostfully_step5} />
        <p>
          <br />
          Click <b>Continue</b>. Hostfully properties you&apos;ve enabled will now import into The
          Host Co.
        </p>
      </div>,

      <img key="hostfully-step6-img" src={hostfullyStepByStepInstructions.hostfully_step6} />,

      <div key="hostfully-step5">
        <b>Step 5 — Create new stores or link existing ones</b>
        <p style={{ marginTop: '15px' }}>
          You&apos;ll now choose how your Host Co stores should be created:
        </p>
        <ul className="Step_SubList">
          <li>
            <b>Create new stores</b> from your Hostfully listings
          </li>
          <li>
            <b>Link with existing Host Co stores</b> (recommended if you&apos;ve already built
            stores)
          </li>
          <li>
            <b>Skip</b> any properties you don&apos;t want to connect yet
          </li>
        </ul>

        <b>New Feature: Link Existing Stores</b>
        <p style={{ marginTop: '15px' }}>
          If you already have Host Co stores and Hostfully listings, you can match them without
          recreating anything. This feature is available across all current and future PMS
          integrations.
        </p>
      </div>,

      <img key="hostfully-step7-img" src={hostfullyStepByStepInstructions.hostfully_step7} />,

      <div key="hostfully-step6">
        <b>Step 6 — Adding new properties later</b>
        <p style={{ marginTop: '15px' }}>If you add new properties to Hostfully in the future:</p>
        <ol style={{ marginLeft: '25px' }}>
          <li>Enable them for Host Co inside Hostfully.</li>
          <li>
            Return to <b>Partners → Hostfully</b> inside The Host Co.
          </li>
          <li>
            Click <b>Continue</b> to import only the new properties.
          </li>
          <li>Create new stores or link them to existing ones.</li>
        </ol>
        <p>Your existing connections won&apos;t be affected.</p>
      </div>,

      <div key="hostfully-step7">
        <b>Step 7 — Find your Host Co store URL inside Hostfully</b>
        <p style={{ marginTop: '15px' }}>
          Once your Host Co stores are connected, Hostfully automatically creates a new custom field
          for each property:
        </p>
        <p>
          <b>{'{{HOSTCO_URL}}'}</b>
        </p>
        <p>To locate it:</p>
        <ol style={{ marginLeft: '25px' }}>
          <li>
            In Hostfully, go to <b>Properties</b>.
          </li>
          <li>Select a property.</li>
          <li>
            Click <b>Custom Data</b>.
          </li>
        </ol>
      </div>,

      <img key="hostfully-step8-img" src={hostfullyStepByStepInstructions.hostfully_step8} />,

      <div key="hostfully-step7-extra">
        <ol start="4" style={{ marginLeft: '25px' }}>
          <li>
            Look for the field titled <b>{'{{HOSTCO_URL}}'}</b> <br />.
          </li>
          <img src={hostfullyStepByStepInstructions.hostfully_step9} /> <br />
          <br />
          <li>
            Copy this link if you&apos;d like to paste it manually anywhere in your Hostfully
            messaging.
          </li>
        </ol>
        <p>This field is created automatically when the integration is connected.</p>
      </div>,

      <div key="hostfully-step8">
        <b>Step 8 — Add your Host Co store link to Hostfully automated messaging</b>
        <p style={{ marginTop: '15px' }}>
          You can add your Host Co store URL into Hostfully messaging templates so guests receive
          your link at booking, pre-arrival, and check-in.
        </p>
        <p>
          <b>Important:</b>
        </p>
        <p>
          The Host Co variable appears only in <b>Custom Templates</b>, not in Hostfully&apos;s
          pre-built default templates.
        </p>
        <p>
          <b>To add it:</b>
        </p>
        <ol style={{ marginLeft: '25px' }}>
          <li>In Hostfully, go to Custom Templates.</li>
          <img src={hostfullyStepByStepInstructions.hostfully_step10} />
          <br />
          <br />
          <li>Create a new template or open an existing one.</li>
          <li>Place your cursor where the store link should appear.</li>
          <li>
            Insert the variable: <b>{'{{HOSTCO_URL}}'}</b>
          </li>
        </ol>
      </div>,

      <img key="hostfully-step11-img" src={hostfullyStepByStepInstructions.hostfully_step11} />,

      <p key="hostfully-step8-note">
        This variable will automatically populate with each property&apos;s specific Host Co store.
      </p>,

      <div key="hostfully-recommended-messaging">
        <b>Recommended messaging</b>
        <p style={{ marginTop: '15px' }}>
          &quot;If you&apos;d like to add amenities like massage, chef, early check-in, or mid-stay
          cleaning, you can view everything available in our store here: <b>{'{{HOSTCO_URL}}'}</b>
          &quot;
        </p>
        <p>
          We recommend sharing your store link at booking, two weeks before check-in, and at
          check-in. For automated messaging templates, visit your Host Co stores, click &quot;Share
          Store.&quot;
        </p>
      </div>,

      <img key="hostfully-step12-img" src={hostfullyStepByStepInstructions.hostfully_step12} />,

      <div key="hostfully-manual-url">
        <b>
          Optional: Manually add a Host Co URL (for hosts using one store across multiple listings)
        </b>
        <p style={{ marginTop: '15px' }}>
          If you prefer to route all properties to a single Host Co store:
        </p>
        <ol style={{ marginLeft: '25px' }}>
          <li>
            Go to <b>Properties</b>.
          </li>
          <li>Select a property.</li>
          <li>
            Click <b>Custom Data</b>.
          </li>
          <img src={hostfullyStepByStepInstructions.hostfully_step13} />
          <br />
          <br />
          <li>Click &quot;Manage global custom fields here.&quot;</li>
          <li>Click &quot;Custom Data.&quot;</li>
          <li>Create a new custom text field, for example &quot;Host Co Store.&quot;</li>
          <img src={hostfullyStepByStepInstructions.hostfully_step14} />
          <br />
          <br />
          <li>Paste your store URL into that field.</li>
          <li>
            Use that custom-field variable in your templates the same way you would use{' '}
            <b>{'{{HOSTCO_URL}}'}</b>.
          </li>
        </ol>
      </div>,

      <p key="hostfully-one-store-note">
        This option is useful if you want one store shared across many listings.
      </p>,

      <div key="hostfully-step9">
        <b>Step 9 — Keep check-in and check-out times in sync</b>
        <p style={{ marginTop: '15px' }}>
          When guests purchase early check-in or late check-out in your Host Co store, their
          reservation times automatically update inside Hostfully.
        </p>
        <p>
          Note: If your Host Co stores were created before May 14, 2025, your Early Check-In and
          Late Check-Out tiles will not sync with Hostfully&apos;s calendar, as these older tiles do
          not include the new required time fields. To fix this, you&apos;ll need to replace your
          old tiles with the updated check-in and check-out tiles, now available for all stores
          under the &quot;quick add&quot; button.
          <a
            href="https://www.youtube.com/watch?v=vMtt_rK4Sgg"
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here
          </a>{' '}
          <b> to learn more. </b>
        </p>
      </div>,

      <img key="hostfully-step15-img" src={hostfullyStepByStepInstructions.hostfully_step15} />,

      <div key="hostfully-blue-dot">
        <b>Optional: Add &quot;blue dot&quot; visual indicators in your Hostfully calendar</b>
        <p style={{ marginTop: '15px' }}>To show visual service dots (early/late indicators):</p>
        <ol style={{ marginLeft: '25px' }}>
          <li>
            In Hostfully, go to <b>Agency Settings → Service Providers</b>.
          </li>
          <li>
            Create a provider named <b>The Host Co</b>.
          </li>
        </ol>
      </div>,

      <img key="hostfully-step16-img" src={hostfullyStepByStepInstructions.hostfully_step16} />,

      <div key="hostfully-blue-dot-services">
        <ol start="3" style={{ marginLeft: '25px' }}>
          <li>
            Once created, click &quot;Add a Service.&quot; Add two services, spelled exactly:
            <ul className="Step_SubList">
              <li>
                <b>early check-in</b>
              </li>
              <li>
                <b>late check-out</b>
              </li>
            </ul>
          </li>
        </ol>
        <p>These two services must be spelled correctly for Hostfully to place the dots.</p>
      </div>,

      <img key="hostfully-step17-img" src={hostfullyStepByStepInstructions.hostfully_step17} />,

      <div key="hostfully-track-sales">
        <b>Keep track of all your sales in your Hostfully calendar</b>
        <p style={{ marginTop: '15px' }}>
          When a purchase is made in The Host Co with a date attached to it, those purchases will
          automatically show up on your Hostfully calendar (as long as the store is linked to a
          specific property).
        </p>
        <p>
          To ensure there&apos;s a date attached, choose a product in The Host Co that you want to
          show up on your calendar and select either &quot;No, I need notice ahead of time&quot; or
          &quot;Yes, it is available immediately but ask guest for date of use.&quot;
        </p>
      </div>,

      <img key="hostfully-step18-img" src={hostfullyStepByStepInstructions.hostfully_step18} />,

      <p key="hostfully-track-sales-note">
        When a guest checks out, they&apos;ll be asked to enter the date of use. That date will
        throw a note onto your calendar in Hostfully. It won&apos;t be visible there unless you
        click on the reservation itself in Hostfully.
      </p>,

      <img key="hostfully-step19-img" src={hostfullyStepByStepInstructions.hostfully_step19} />,

      <p key="hostfully-track-sales-ending">
        Now, it&apos;s never been easier to track your Host Co sales across platforms!
      </p>,

      <div key="hostfully-help">
        <b>Need more help?</b>
        <p style={{ marginTop: '15px' }}>
          If you&apos;d like help setting up your store or learning about the types of upsells you
          can offer, join one of The Host Co&apos;s
          <a
            href="http://thehost.co/get-started"
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            daily live demos
          </a>{' '}
          available on their website.
        </p>
        <p>
          For product-specific support, reach out to <b>support@thehost.co</b>
        </p>
      </div>,
    ],

    onContinue: () => hostfullyApi.authenticate(),
  },
};

partnersData.hosttools = {
  name: IntegrationType.HOST_TOOLS,
  title: 'Get Started',
  copy: 'Learn how to import your Host Tools properties with this video.',
  videos: [
    {
      id: 'E1rvhp7jxBU',
      title: 'How it Works',
      start: 84,
    },
  ],
  heading: 'Quick-Start Instructions',
  quick_start_instructions: [
    <ol key="part1" style={{ paddingLeft: '20px', marginBottom: '0' }}>
      <li>
        Click <strong>continue</strong> to connect your Host Tools account.
      </li>
    </ol>,

    <div key="part2" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <ol
        start="2"
        style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}
      >
        <li>
          You’ll be asked for a HostTools integration token. If you don’t already have one, click{' '}
          <strong>API & Integrations</strong>. You’ll be taken to the HostTools integrations
          page—select <strong>The Host Co</strong> and copy your integration token.
        </li>
        <li>
          On The Host Co site, paste your integration token into the provided form (this is only
          required once).
        </li>
        <li>
          Choose how you’d like to connect your properties:
          <ul>
            <li>
              Create new Host Co stores. This creates a Host Co store for each of your HostTools
              listings.{' '}
            </li>
            <li>Link existing Host Co stores to HostTools properties</li>
            <li>
              Or skip any properties you don’t want to connect (you can always add more later)
            </li>
          </ul>
        </li>
        <li>
          Each Host Co store link automatically syncs with HostTools. Add it to your automated guest
          messages using the message tag <pre>{'{{Upsell URL}}'}</pre> to share the correct store
          with each guest.
        </li>
        <li>
          We recommend sharing your store:
          <ul>
            <li>In your “Thanks for booking” message</li>
            <li>One week before check-in</li>
            <li>In your check-in notes</li>
            <li>For message templates, click “Share” on any Host Co store.</li>
          </ul>
        </li>
      </ol>

      <strong>Note on Early Check-In & Late Check-Out</strong>
      <p>
        The Host Co Early Check-In and Late Check-Out tiles can automatically update your HostTools
        booking times (with your approval),{' '}
        <strong>unless your Host Co stores were created before May 14, 2025.</strong>
      </p>
      <p>
        If your stores were created before this date, these tiles will not sync with the HostTools
        calendar because older versions don’t include the required time fields.
      </p>
      <p>
        <strong>To fix this: </strong>
        replace your old tiles with the updated versions.
      </p>
      <p>
        <a href="https://www.youtube.com/watch?v=vMtt_rK4Sggtform.hostfully.com/app/#/integrations">
          Click here to learn more.
        </a>
      </p>
    </div>,
    INTEGRATION_INSTRUCTIONS(IntegrationType.HOST_TOOLS),
  ],
  onContinue: () =>
    reverse({
      url: URLS.INTEGRATION,
      params: { company: IntegrationType.HOST_TOOLS.replace(' ', '').toLowerCase() },
    }),
};

export const listPartners = [
  // Airbnb
  {
    key: 'Airbnb',
    image: airbnbLogo,
    description:
      'Automatically create stores for all of your Airbnb properties. Partnership provided by Hospitable Connect.',
    action: (history) => {
      history.push('/overview/integrations/landing/hospitableconnect/');
    },
  },
  // Guesty
  {
    key: 'Guesty',
    image: guestyLogo,
    description: 'Automatically create stores for your Guesty properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/guesty/');
    },
  },

  // Guesty Lite
  {
    key: 'Guesty Lite',
    image: guestyLiteDarkLogo,
    description: 'Automatically create stores for your Guesty properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/guesty_lite/');
    },
  },
  // Haven
  {
    key: IntegrationType.HAVEN,
    image: havenLogo,
    description: 'Create beautiful direct booking websites and automate your Host Co upsells.',
    action: () => {
      window.open('https://www.bookwithhaven.com/', '_blank');
    },
  },

  // HOST TOOLS
  {
    key: IntegrationType.HOST_TOOLS,
    image: hosttoolsLogo,
    description: 'Automatically create stores for your Host Tools properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/hosttools/');
    },
  },

  // Hostaway
  {
    key: 'Hostaway',
    image: hostawayLogo,
    description: 'Automatically create stores for your Hostaway properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/hostaway/');
    },
  },
  // Hostbuddy
  {
    key: IntegrationType.HOSTBUDDY,
    image: hostbuddyLogo,
    description: 'Automate guest messaging and supercharge your upsells with AI.',
    action: () => {
      window.open('https://www.hostbuddy.ai/hostco', '_blank');
    },
  },
  // HOSTFULLY
  {
    key: IntegrationType.HOSTFULLY,
    image: hostfullyLogo,
    description: 'Automatically create stores for your Hostfully properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/hostfully/');
    },
  },
  // Hospitable
  {
    key: 'Hospitable',
    image: hospitableLogo,
    description: 'Automatically create stores for your Hospitable properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/hospitable/');
    },
  },

  // Lodgify
  {
    key: 'Lodgify',
    image: lodgifyLogo,
    description: 'Automatically create stores for your Lodgify properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/lodgify/');
    },
  },

  // Ownerrez
  {
    key: 'Ownerrez',
    image: ownerRezLogo,
    description: 'Automatically create stores for your OwnerRez properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/ownerrez');
    },
  },

  // StayFi
  {
    key: 'StayFi',
    image: stayFiLogo,
    description: 'Send guests to your Host Co Store after they log in to your StayFi Wi-Fi.',
    action: () => {
      window.open('https://www.thehost.co/stayfi', '_blank');
    },
  },

  // TouchStay
  {
    key: 'TouchStay',
    image: touchStayLogo,
    description: 'Add a Host Co store to your Touch Stay Digital Guide Book.',
    action: () => {
      window.open('https://www.thehost.co/touch-stay', '_blank');
    },
  },

  // TURNO
  {
    key: IntegrationType.TURNO,
    image: turnoLogo,
    description: 'Automatically create stores for your Turno properties.',
    action: (history) => {
      history.push('/overview/integrations/landing/turno/');
    },
  },
];
